import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { useElementDOMProperty } from "../../hooks";
import { fieldChanged, focusOn } from "../../store/actions";
import useCloseOnBlur from "../use-close-on-blur";
import "./styles.css";

const mapDispatchToProps = dispatch => ({
  fieldChanged: fieldName => dispatch(fieldChanged(fieldName)),
  focusOn: fieldName => dispatch(focusOn(fieldName))
});

const Select = ({
  fieldName,
  fieldChanged,
  focusOn,
  focusedField,
  id,
  setId,
  entries,
  error
}) => {
  const onSelectChange = React.useCallback(
    ev => {
      setId(ev.target.value);
      if (fieldName) {
        fieldChanged(fieldName);
      }
    },
    [setId, fieldName, fieldChanged]
  );

  const onFocus = useCloseOnBlur(focusOn, fieldName, focusedField);

  const {
    domProperty: errorTextHeight,
    elementRef: errorTextRef
  } = useElementDOMProperty(
    { getDOMProperty: el => el.offsetHeight, defaultValue: 0 },
    [error]
  );

  return (
    <div styleName="select-container" id={`input-field-name-${fieldName}`}>
      <select
        styleName="select"
        value={id}
        onChange={onSelectChange}
        onClick={onFocus}
      >
        {entries.map(({ id, value: entryValue }) => (
          <option key={id} value={id}>
            {entryValue}
          </option>
        ))}
      </select>
      <div styleName="caret">
        <i className="fa fa-angle-down"></i>
      </div>
      <div styleName="error" style={{ height: errorTextHeight }}>
        <div ref={errorTextRef}>{error}</div>
      </div>
    </div>
  );
};

const numberOrString = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string
]);

Select.propTypes = {
  fieldName: PropTypes.string,
  fieldChanged: PropTypes.func.isRequired,
  focusOn: PropTypes.func.isRequired,
  focusedField: PropTypes.string,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: numberOrString,
      value: numberOrString
    })
  ).isRequired,
  id: numberOrString,
  setId: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default connect(
  (_, ownProps) => ownProps,
  mapDispatchToProps
)(Select);
